import { BaseModal, TextWarning } from '@isdd/idsk-ui-kit'
import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './autoLogout.module.scss'

import { ModalButtons } from '@isdd/metais-common/components/modal-buttons/ModalButtons'
import { NARROW_MODAL_WIDTH_IN_PX } from '@isdd/metais-common/constants'

type Props = {
    isOpen: boolean
    onClose: () => void
    countDown: number
}

export const AutoLogoutWarningModal = ({ isOpen, onClose, countDown }: Props) => {
    const { t } = useTranslation()
    return (
        <BaseModal isOpen={isOpen} close={onClose} widthInPx={NARROW_MODAL_WIDTH_IN_PX}>
            <div className={styles.messageDiv}>
                <TextWarning>{t('autoLogout.warningMessage', { countDown })}</TextWarning>
            </div>
            <ModalButtons onClose={onClose} closeButtonLabel={t('autoLogout.cancel')} />
        </BaseModal>
    )
}
